<script>
	import {onMount} from 'svelte'
	import FormInput from '../components/form-input.svelte'
	import SelectInput from '../components/select-input.svelte'
	import {execQuery,execMutation} from '../csql.js'
	import {usuario} from '../store.js'

	export let handler = () => console.log("Unhandled action")
	export let email=''


	let randomClave = 'mayo2021' //Math.floor((Math.random() * 9000) + 1000)
	let clave = ''
	let formdata = {email:email,clave:randomClave}
	let loading = false

	function submit(){
		if(sanitize()){
			//console.log(formdata)
			guardar()
		}
	}

	function reset(){
		handler({response:-1,view_dst:'login'})
	}

	async function guardar(){
		if(clave===randomClave){
			formdata.tipo = 'MAYO'
		}

		loading = true
		let data = {
			tabname: 'usuarios', 
			mutation: (formdata && formdata.id && formdata.id>0) ? 'update' : 'insert',
			mutationId: 'id',
			params: formdata
		}
		const res = await execMutation(data)
		loading = false
		if(res && res.success==="OK"){

			let usr = formdata
			usuario.set(usr)
			let temp_clave = usr.clave+''
			delete usr.clave
			localStorage.setItem('UPM_USER',JSON.stringify({user:usr}))

			alert(`Alta exitosa, ${formdata.email}, tu codigo de acceso es ${temp_clave}`)

			handler({response:0,view_dst:'catalogo'})
		}else{
			alert("ERROR, no se realizo actualizacion!!!")
		}
	}

	function sanitize(){
		if( (formdata["email"] || "").trim() === ""  || (formdata["email"] || "").trim().length<8) return false
		formdata["id"] = formdata["id"]
		formdata["email"] = (email || "").trim().toLowerCase()
		formdata["nombre"] = (formdata["nombre"] || "").trim().toUpperCase()
		formdata["apellido"] = (formdata["apellido"] || "").trim().toUpperCase()
		formdata["cuit"] = (formdata["cuit"] || "0").trim()
		formdata["domicilio"] = (formdata["domicilio"] || "").trim()
		formdata["ciudad"] = (formdata["ciudad"] || "").trim()
		formdata["provincia"] = (formdata["provincia"] || "").trim()
		formdata["codpostal"] = (formdata["codpostal"] || "").trim()
		formdata["telefono"] = (formdata["telefono"] || "").trim()
		formdata["tipo"] = (formdata["tipo"] || "MAYO").trim()
		formdata["observ"] = (formdata["observ"] || "").trim()
		formdata["activo"] = 1
		formdata["clave"] = formdata["clave"]||''

		if(formdata.clave.length<4){
			alert("la clave debe ser al menos de 4 caracteres")
			return false
		} 


		return true
	}
	
	let provincias_ds = []

	onMount( async () => {
		loading = true 
		let query = `select * from provincias order by id`
		const data = await execQuery({query})
		loading= false
		provincias_ds = data.data[0] || {}
	})

</script>


<div class="modal" on:click|self={()=>handler(-1)}>
	<div class="container" style="background-color: white;">

		<form on:submit|preventDefault={submit} on:reset|preventDefault={reset}>
			<p>Aun no estas registrado, por favor completa la siguiente info.</p>

		  <fieldset>
		  	<legend>Registrar Usuario</legend>
		  	<!-- <small>Se realizara registro como MINORISTA, si deseas realizar compras por mayor finaliza este registro y luego contactanos por whatApp 01144444444</small> -->
		  	<div class="row">
				<div class="col-sm">
					<FormInput label="" bind:value={formdata.email} readonly={true}/>
				</div>
			</div>		
		    <div class="row">
		      <div class="col-sm-6">
		        <FormInput label="Nombre" bind:value={formdata.nombre} />
		      </div>
		      <div class="col-sm-6">
		        <FormInput label="Apellido" bind:value={formdata.apellido} />
		      </div>
		    </div>
		    <div class="row">
				<div class="col-sm">
					<FormInput label="Domicilio" bind:value={formdata.domicilio} />
				</div>
			</div>	
			<div class="row">
				<div class="col-sm-8">
					<FormInput label="Telefono" bind:value={formdata.telefono} />
				</div>
				<div class="col-sm-4">
					<FormInput label="DNI / CUIT" bind:value={formdata.cuit} />
				</div>
			</div>	
			<div class="row">
				<div class="col-sm-12">
					{#if loading} 
						<div class="spinner"></div>	
					{:else}
						<SelectInput label="Provincia" bind:value={formdata.provincia} data={provincias_ds.map(v => v.nombre)}/>
					{/if}
				</div>
			</div>	
			<div class="row">
				<div class="col-sm-8">
					<FormInput label="Ciudad" bind:value={formdata.ciudad} />
				</div>
				<div class="col-sm-4">
					<FormInput label="Cod. Postal" bind:value={formdata.codpostal} />
				</div>
			</div>
			<input type="hidden" bind:value={formdata.clave} />
<!--
 			<div class="row">
				<div class="col-sm-6">
					<FormInput label="Clave" bind:value={formdata.clave} />
				</div>
				<div class="col-sm-6 v-center">
					<small>Esta sera tu clave de acceso, por favor recordala!</small>
				</div>
			</div>
 -->
 		    <div class="row">
		    	<div class="col-sm text-right">
		    		<button class="ok" type="submit">Aceptar</button>
		    		<button class="cancel" type="reset">Cancelar</button>
		    	</div>
		    </div>

		  </fieldset>
		</form>




	</div>
</div>